export default {
}



// WEBPACK FOOTER //
// ./src/app/dweller/files/index/resources/computed.js